const { locations: { codeSwap = {}, airportMatch = {}, extraAirports = {} } } = require('../../../../config/generatedConfig')
const airportCodes = require('../../../../config/exports/airportCodes.json')

const getAirportInfo = (pageName) => {
  let location
  const airportsList = Object.assign({}, airportCodes, extraAirports)
  Object.keys(airportsList).map(key => {
    const item = airportsList[key]
    const regEx = new RegExp(item.pattern)
    if ((regEx).test(pageName)) {
      location = {
        name: item.name,
        code: codeSwap[item._airport] || item._airport,
        pattern: item.pattern
      }
    }
    return key
  })
  if (!location && airportMatch.hasOwnProperty(pageName.replace('.html', ''))) {
    location = airportMatch[pageName.replace('.html', '')]
  }
  return location
}

module.exports = getAirportInfo



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/getAirportInfo.js